<div class="modal-container">
  <div class="modal-header">
    <div class="header-title">
      {{ 'home.preferences-cookie.dialog.title' | translate }}
    </div>
    <svg class="header-divider" width="768" height="1" viewBox="0 0 768 1">
      <path d="M0 0H768V1H0V0Z" fill="white"></path>
    </svg>
  </div>

  <div class="modal-body">
    <div class="options">
      <button class="option-btn privacy" [ngClass]="{ active: selectedOption === PolicyOptions.Mandatory }" (click)="selectOption(PolicyOptions.Mandatory)">
        {{ 'home.preferences-cookie.mandatory-section.menuTitle' | translate }}
      </button>
      <button class="option-btn cookies" [ngClass]="{ active: selectedOption === PolicyOptions.Analytics }" (click)="selectOption(PolicyOptions.Analytics)">
        {{ 'home.preferences-cookie.analytical-section.menuTitle' | translate }}
      </button>
    </div>
    <svg class="vertical-divider" width="1" height="470" viewBox="0 0 1 470">
      <line x1="0.5" y1="470" x2="0.5" stroke="white"></line>
    </svg>

    <div class="body-text scrollable-content" *ngIf="selectedOption === PolicyOptions.Mandatory">
      <h3><div class="policy-text" [innerHTML]="'home.preferences-cookie.mandatory-section.text-mandatory' | translate"></div></h3>

      <div class="preferences-table">
        <table>
          <thead>
            <tr>
              <th>{{ 'home.preferences-cookie.menu.menuName' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuValue' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuGoal' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuValidity' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuType' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuUse' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ 'home.preferences-cookie.googleAnalyticsCookiesProperties.name' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleAnalyticsCookiesProperties.supplier' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleAnalyticsCookiesProperties.goal' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleAnalyticsCookiesProperties.validity' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleAnalyticsCookiesProperties.type' | translate }}</td>
              <td>
                <div class="checkbox-container">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <rect width="24" height="24" rx="4" fill="white" />
                    <path *ngIf="checkStates['googleAnalytics']" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#105C8D" />
                  </svg>
                </div>
              </td>
            </tr>
            <tr>
              <td>{{ 'home.preferences-cookie.googleCookiesProperties.name' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleCookiesProperties.supplier' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleCookiesProperties.goal' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleCookiesProperties.validity' | translate }}</td>
              <td>{{ 'home.preferences-cookie.googleCookiesProperties.type' | translate }}</td>
              <td>
                <div class="checkbox-container">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <rect width="24" height="24" rx="4" fill="white" />
                    <path *ngIf="checkStates['google']" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#105C8D" />
                  </svg>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="body-text scrollable-content" *ngIf="selectedOption === PolicyOptions.Analytics">
      <h3><div class="policy-text" [innerHTML]="'home.preferences-cookie.analytical-section.text-analytical' | translate"></div></h3>
      <div class="preferences-table">
        <table>
          <thead>
            <tr>
              <th>{{ 'home.preferences-cookie.menu.menuName' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuValue' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuGoal' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuValidity' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuType' | translate }}</th>
              <th>{{ 'home.preferences-cookie.menu.menuUse' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ 'home.preferences-cookie.hotjarCookiesProperties.name' | translate }}</td>
              <td>{{ 'home.preferences-cookie.hotjarCookiesProperties.supplier' | translate }}</td>
              <td>{{ 'home.preferences-cookie.hotjarCookiesProperties.goal' | translate }}</td>
              <td>{{ 'home.preferences-cookie.hotjarCookiesProperties.validity' | translate }}</td>
              <td>{{ 'home.preferences-cookie.hotjarCookiesProperties.type' | translate }}</td>
              <td>
                <div class="checkbox-container" (click)="toggleCheckbox('hotjar')">
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <rect width="24" height="24" rx="4" fill="white" />
                    <path *ngIf="checkStates['hotjar']" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#105C8D" />
                  </svg>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <svg class="footer-divider" width="768" height="1" viewBox="0 0 768 1">
      <path d="M0 0H768V1H0V0Z" fill="white"></path>
    </svg>
    <div class="footer-actions">
      <button mat-button [mat-dialog-close] (click)="onAccept()" class="cancel-btn">
        {{ 'home.preferences-cookie.dialog.cancel-button' | translate }}
      </button>
      <button mat-button [mat-dialog-close] (click)="onAccept()" class="confirm-btn">
        {{ 'home.preferences-cookie.dialog.confirm-button' | translate }}
      </button>
    </div>
  </div>
</div>
